import {
    FullPart,
    isCustomComponentFull,
    isCustomFullPart,
    isGenericFullPart,
    isOtsComponentFull,
    isOtsFullPart,
} from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';
import { Tag } from '@luminovo/design-system';

export const getTypeLabel = (part: FullPart): string => {
    if (isOtsFullPart(part) || isGenericFullPart(part) || isOtsComponentFull(part)) {
        return 'Off-the-shelf';
    }
    if (isCustomComponentFull(part) || isCustomFullPart(part)) {
        return 'Custom';
    }
    assertUnreachable(part);
};

export const SpecificationTypeTag = ({ part }: { part: FullPart }) => {
    return <Tag color="neutral" label={getTypeLabel(part)} attention="low" />;
};
